import { getPage } from 'Utils'
import config from 'Config'

export const getContentsQueryVariables = (
  queryString,
  size,
  type,
  isFeatured
) => {
  const urlParams = new URLSearchParams(queryString)
  let theme = {}
  if (queryString) {
    if (urlParams.get('theme')) {
      theme = {
        theme: urlParams.get('theme')
      }
    }
  }

  let celebrity = {}
  if (queryString) {
    if (urlParams.get('celebrity')) {
      celebrity = {
        celebrity: urlParams.get('celebrity')
      }
    }
  }

  const query = {
    arguments: {
      type,
      state: 'PUBLISHED',
      ...theme,
      ...celebrity
    },
    pagination: {
      page: getPage(queryString),
      size: size || config.pagination.articleList
    }
  }

  if (isFeatured) {
    query.arguments.isFeatured = true
  }
  return query
}
